import React from 'react'

import { Box, Flex, Icon, Text } from 'stardust'

import {
  AlignItemsProps,
  BorderRadiusProps,
  ColorProps,
  LineHeightProps,
  FontSizeProps,
  FontWeightProps,
  LetterSpacingProps,
  SpaceProps,
  TextColorProps,
  GridColumnGapProps,
  BorderColorProps,
} from 'styled-system'

const defaultPadding = 2
const defaultMarginRight = 2
const defaultFontSize = 0
const defaultBorderRadius = 1
const defaultIconSize = 16
const defaultIconMarginRight = 2

type PillStyledProps = AlignItemsProps &
  BorderRadiusProps &
  BorderColorProps &
  ColorProps &
  LineHeightProps &
  FontSizeProps &
  FontWeightProps &
  LetterSpacingProps &
  SpaceProps &
  GridColumnGapProps &
  TextColorProps

const DEFAULT_COLOR = 'rgba(0, 0, 0, 0.04)'

interface PillProps extends PillStyledProps {
  color?: string
  icon?: string
  textColor?: string
  text: string
}

const Pill = (props: PillProps) => {
  const {
    icon,
    text,
    textColor,
    fontWeight,
    letterSpacing,
    lineHeight,
    fontSize = defaultFontSize,
    color,
    ...rest
  } = props

  const fontProps = {
    fontSize,
    fontWeight,
    letterSpacing,
    lineHeight,
    color: textColor,
  }

  return (
    <Box
      bg={color || DEFAULT_COLOR}
      borderColor="surfacePrimaryBorder"
      p={defaultPadding}
      mr={defaultMarginRight}
      borderRadius={defaultBorderRadius}
      width="auto"
      {...rest}>
      <Flex alignItems="center">
        {icon && <Icon name={icon} width={defaultIconSize} mr={defaultIconMarginRight} />}
        <Text.span medium={!textColor} {...fontProps}>
          {text}
        </Text.span>
      </Flex>
    </Box>
  )
}

Pill.displayName = 'Pill'

export default React.memo(Pill)
